import image1 from '../../assets/home/testimonial1.png';
import image2 from '../../assets/home/testimonial2.png';
import image3 from '../../assets/home/testimonial2.png';

export const fakeData = [
    {
        id: 1,
        //img: image1,
        name: 'Razzac Abdulla',
        profession: 'Exceptional Professional Support',
        message: "Al Rimal provided outstanding consultancy services with excellent professionalism and clear guidance throughout the process."
    },
    {
        id: 2,
        //img: image2,
        name: 'Abdul Muhammed',
        profession: 'Reliable Financial Expertise',
        message: "The team delivered accurate financial solutions and helped us manage compliance smoothly and efficiently."
    },
    {
        id: 3,
        //img: image3,
        name: 'Mahesh Raghav',
        profession: 'Highly Recommended Services',
        message: "Professional, responsive, and knowledgeable team. Their support made our business operations much easier."
    },
    {
        id: 4,
        //img: image1,
        name: 'Gupta Shankar',
        profession: 'Smart Digital Solutions',
        message: "Al Rimal’s digital solutions improved our workflow and helped us streamline our daily business operations."
    },
    {
        id: 5,
        //img: image2,
        name: 'Mujeeb Muzaffir',
        profession: 'Trusted Business Partner',
        message: "Their expert advisory services and client-focused approach gave us confidence in every business decision."
    },
    {
        id: 6,
        //img: image3,
        name: 'Ram Mohan',
        profession: 'Excellent Client Experience',
        message: "From consultation to execution, the entire experience with Al Rimal was smooth, transparent, and highly professional."
    },
]